import * as React from 'react';
import { ViewContainer } from '../ViewContainer';
import { TitleContainer } from '../TitleContainer';
import { SocialContainer } from '../SocialContainer';
import { Help } from '../../_NEXT_components/Help';
import { PhoneSmsConfirmationInfoContainer } from '../PhoneSmsConfirmationInfoContainer';
import { ConfirmPhoneFormContainer } from '../ConfirmPhoneFormContainer';
import { trackConfirmPhoneShown, trackLoginNeedHelp } from '../../utils/tracking';
export function ConfirmPhoneViewContainer() {
  React.useEffect(function () {
    trackConfirmPhoneShown();
  }, []);
  return /*#__PURE__*/React.createElement(ViewContainer, null, /*#__PURE__*/React.createElement(TitleContainer, null), /*#__PURE__*/React.createElement(PhoneSmsConfirmationInfoContainer, null), /*#__PURE__*/React.createElement(ConfirmPhoneFormContainer, null), /*#__PURE__*/React.createElement(SocialContainer, null), /*#__PURE__*/React.createElement(Help, {
    onClick: trackLoginNeedHelp
  }));
}